import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.SORT_COLUMNS, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) =>
  Helpers.coalesceMessages(
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      config.sortOptions.map(({column}) => column),
      'Cannot sort the same column more than once.'
    )
  );

export default {
  stepType: PipelineStepType.SORT_COLUMNS,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.SORT_COLUMNS, 0>;
